import { AZURE, bandStyle, formatNumber, GOOD, MUTED, MUTED_2, sectionMetaStyle, sectionTitleStyle, SOFT_BORDER, TEXT } from "../shared/styles";

function scalePosition(value, max) {
  if (!Number.isFinite(value) || max <= 0) return 0;
  return Math.max(0, Math.min(100, (value / max) * 100));
}

export default function NetZeroProgressSection({ netZero }) {
  const progressPct = netZero?.progressPct ?? null;
  const thresholdPct = netZero?.thresholdPct ?? null;
  const year = netZero?.year ?? null;
  const onTrack = netZero?.onTrack ?? null;
  const notice = netZero?.notice ?? null;
  const scaleMax = Math.max(netZero?.scaleMaxPct ?? 100, thresholdPct ?? 0, progressPct ?? 0, 100);

  const hasProgress = progressPct != null;
  const thresholdPos = thresholdPct != null ? scalePosition(thresholdPct, scaleMax) : null;
  const progressPos = hasProgress ? scalePosition(progressPct, scaleMax) : null;

  return (
    <section style={bandStyle}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem", flexWrap: "wrap", alignItems: "flex-start" }}>
        <div>
          <h2 className="h2" style={sectionTitleStyle}>Netto-Null-Kurs</h2>
          <p style={sectionMetaStyle}>
            Fortschritt zur gesetzlich vorgegebenen Netto-Null bis 2050{year ? ` (Stand ${year})` : ""}.
          </p>
        </div>
        {onTrack != null && (
          <span
            style={{
              borderRadius: 999,
              padding: "0.35rem 0.85rem",
              border: `1px solid ${onTrack ? "#86efac" : "#fecaca"}`,
              background: onTrack ? "#ecfdf3" : "#fef2f2",
              color: onTrack ? GOOD : "#b91c1c",
              fontSize: "0.8rem",
              fontWeight: 700,
              whiteSpace: "nowrap"
            }}
          >
            {onTrack ? "On Track" : "Nicht on Track"}
          </span>
        )}
      </div>

      <div style={{ marginTop: "1.25rem", display: "flex", alignItems: "baseline", gap: "0.4rem" }}>
        <strong style={{ fontSize: "1.6rem", color: hasProgress ? TEXT : MUTED, lineHeight: 1, fontVariantNumeric: "tabular-nums" }}>
          {hasProgress ? formatNumber(progressPct, 2) : "-"}
        </strong>
        <span style={{ fontSize: "0.85rem", color: MUTED, fontWeight: 600 }}>% Fortschritt</span>
      </div>

      <div style={{ position: "relative", height: 14, background: "#edf1f5", borderRadius: 999, marginTop: "1.4rem", marginBottom: "1.6rem" }}>
        {thresholdPos != null && (
          <div
            style={{
              position: "absolute",
              left: `${thresholdPos}%`,
              right: 0,
              top: 0,
              bottom: 0,
              background: "rgba(21, 128, 61, 0.14)",
              borderRadius: "0 999px 999px 0"
            }}
          />
        )}
        {hasProgress && (
          <div style={{ position: "absolute", left: 0, top: 0, bottom: 0, width: `${progressPos}%`, background: AZURE, borderRadius: 999 }} />
        )}
        {thresholdPos != null && (
          <div style={{ position: "absolute", left: `${thresholdPos}%`, top: -6, width: 3, height: 26, background: GOOD, borderRadius: 1 }} />
        )}
      </div>

      {thresholdPct != null && (
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.76rem", color: MUTED }}>
          <span>0%</span>
          <span style={{ color: GOOD, fontWeight: 700 }}>Netto-Null kompatibel ab {formatNumber(thresholdPct, 2)}%</span>
          <span>{formatNumber(scaleMax, 0)}%</span>
        </div>
      )}

      {notice && (
        <div style={{ marginTop: "1rem", paddingTop: "0.85rem", borderTop: `1px dashed ${SOFT_BORDER}`, fontSize: "0.76rem", color: MUTED_2 }}>
          {notice}
        </div>
      )}

      {!notice && (
        <div style={{ marginTop: "1rem", paddingTop: "0.85rem", borderTop: `1px dashed ${SOFT_BORDER}`, fontSize: "0.76rem", color: MUTED_2 }}>
          Die Schwelle steigt jährlich (bis 2050 linear auf 100%) und wird pro Reportingjahr neu berechnet.
        </div>
      )}
    </section>
  );
}
